import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles,
    border: '0px'
  },
  selectContainer: {
    margin: theme.spacing(0, 1),
    // minWidth: 180,
    display: 'flex',
    alignItems: 'center'
  },
  boxForms: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: '4px 12px',
  },
  buttonActionEdit: {
    padding: '4px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  buttonActionDelete: {
    padding: '4px',
    borderRadius: 8,
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },
  buttonActionWhatsapp: {
    padding: '4px',
    borderRadius: 8,
    color: theme.palette.green_whatsApp.main,
    '&:hover': {
      backgroundColor: theme.palette.green_whatsApp.main,
      color: theme.palette.white_100.main
    },
    '& svg':{
      fontSize: '20px'
    }
  },
  containerPagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 4px',
    
  },
  countPerPage: {
    marginLeft: 16,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  exibitionPagination: {
    display: 'flex',
    alignItems: 'center',
    gap: 24
  },
  perPageSelect: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& p': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  buttonNext: {
    backgroundColor: 'transparent',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main
    }
  },
  pageNumberOfRowsPage: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    margin: '0 16px'
  }
}))
